import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import 'vuetify/dist/vuetify.min.css';
import Toast from 'vue-toastification';
import 'vue-toastification/dist/index.css';

// Importar estilos globales Sprintly
import '@/assets/sprintly-global.scss';

// Importar servicios
import { authService } from '@/services/auth.service';

Vue.config.productionTip = false;

// Leer el tema guardado en localStorage o usar oscuro por defecto
const savedTheme = JSON.parse(localStorage.getItem('isDark') || 'true');
vuetify.framework.theme.dark = savedTheme;

// Configuración de vue-toastification
const toastOptions = {
  position: 'top-right',
  timeout: 4000,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  draggablePercent: 0.6,
  showCloseButtonOnHover: false,
  hideProgressBar: false,
  closeButton: 'button',
  icon: true,
  rtl: false,
  transition: 'Vue-Toastification__bounce',
  maxToasts: 5,
  newestOnTop: true,
};

Vue.use(Toast, toastOptions);

// Verificar autenticación al iniciar la aplicación
store.dispatch('auth/updateTokenStatus');

// Log de inicialización
console.log('🚀 Iniciando aplicación FDPA v5.0.0');
console.log('🔐 Estado de autenticación:', authService.isAuthenticated());

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount('#app');